import View from './AnimationWrapper'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  categories: state.categories.categories,
  isHomePage: state.router.activeRoute.name === 'homepage',
  locale: state.router.locale,
  collapsed: state.header.collapsed,
})

const SecondaryNavigation = connect(mapStateToProps)(View)

export default SecondaryNavigation
